import React, { memo } from 'react';
import { Box, Container, Heading, Text, Stack, Image, Flex } from '@chakra-ui/react';
import { motion } from 'framer-motion';
const MotionBox = motion(Box);
export const AboutSection = memo(function AboutSection() {
  return <Box id="about" as="section" py={16} bg="white" data-id="element-8">
      <Container maxW="container.md" data-id="element-9">
        <MotionBox initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} data-id="element-10">
          <Stack spacing={6} data-id="element-11">
            <Heading as="h2" size="xl" textAlign="center" data-id="element-12">
              About Me
            </Heading>
            <Flex direction={{
            base: 'column',
            md: 'row'
          }} align="center" gap={8} mt={4} data-id="element-13">
              <Box flexShrink={0} data-id="element-14">
                <Image src="https://uploadthingy.s3.us-west-1.amazonaws.com/8CEXtjJmx3LKgwP68QaiJF/martin.webp" alt="Martin Randula - Product Manager" borderRadius="full" boxSize={{
                base: '150px',
                md: '200px'
              }} objectFit="cover" shadow="lg" loading="eager" fetchpriority="high" width="200px" height="200px" decoding="async" data-id="element-15" />
              </Box>
              <Stack spacing={4} flex={1} data-id="element-16">
                <Text fontSize="lg" color="gray.700" lineHeight="tall" data-id="element-17">
                  I'm Martin, a product manager who uses AI to build real tools
                  without needing to write much code. Quick prototyping helps me
                  test ideas fast and keep only what actually solves problems.
                </Text>
                <Text fontSize="lg" color="gray.700" lineHeight="tall" data-id="element-18">
                  Here you'll find the tools and mini-projects I use daily — in
                  case they inspire your own experiments.
                </Text>
              </Stack>
            </Flex>
            <Box bg="purple.50" p={4} borderRadius="md" borderLeft="4px solid" borderColor="#2c0842" mt={4} data-id="element-19">
              <Text fontSize="sm" color="gray.700" data-id="element-20">
                <strong data-id="element-21">Full transparency:</strong> Some links on this site are
                referral links. If you sign up through them, I get credits that
                help me keep experimenting and building more tools like these. I
                only recommend tools I actually use daily.
              </Text>
            </Box>
          </Stack>
        </MotionBox>
      </Container>
    </Box>;
});